export const SERVICE_PROVIDERS = {
  dhl: "dhl",
  flash: "flash",
  jnt: "jnt",
  ninjavan: "ninjavan",
  citylink: "citylink",
  pickupp: "pickupp",
  teleport: "teleport",
  poslaju: "poslaju",
  sfstandard: "sfstandard",
  sfexd: "sfexd",
  sfeconomy: "sfeconomy",
  fedex: "fedex",
  imile: "imile",
  redly: "redly",
  best: "best",
  aramex: "aramex",
  lineclear: "lineclear",
  spx: "spx",
  kex: "kex",
  lex: "lex",
  bestcargo:"bestcargo"
};

export const SERVICE_PROVIDER_DETAILS = [
  {
    key: "dhl",
    name: "DHL",
    hasPickup: true,
  },
  {
    key: "flash",
    name: "Flash",
    isClosed: true
  },
  {
    key: "jnt",
    name: "J&T",
  },
  {
    key: "ninjavan",
    name: "Ninjavan",
  },
  {
    key: "citylink",
    name: "Citylink",
    isManualCancel: true,
  },
  {
    key: "teleport",
    name: "Teleport",
  },
  {
    key: "poslaju",
    name: "Poslaju",
    isManualCancel: true,
  },
  {
    key: "sfstandard",
    name: "SF Standard",
  },
  {
    key: "sfeconomy",
    name: "SF Economy",
  },
  {
    key: "fedex",
    name: "Fedex",
    isPublic: false,
  },
  {
    key: "aramex",
    name: "Aramex",
    hasPickup: true,
    isManualCancel: true,
  },
  {
    key: "redly",
    name: "Redly",
    isManualCancel: true,
  },
  {
    key: "lineclear",
    name: "Lineclear",
  },
  {
    key: "best",
    name: "Best",
  },
  {
    key: "spx",
    name: "SPX",
  },
  {
    key: "lex",
    name: "LEX",
  },
  {
    key: "kex",
    name: "KEX",
  },
  {
    key: "pickupp",
    name: "Pickupp",
  },
  {
    key: "sfexd",
    name: "SF Exd",
  },
  {
    key: "bestcargo",
    name: "Best Cargo",
  },
];

export const COD_SERVICE_PROVIDERS = [
  SERVICE_PROVIDERS.dhl,
  SERVICE_PROVIDERS.ninjavan,
  SERVICE_PROVIDERS.jnt,
  SERVICE_PROVIDERS.poslaju,
  SERVICE_PROVIDERS.citylink,
  SERVICE_PROVIDERS.imile,
  SERVICE_PROVIDERS.redly,
  SERVICE_PROVIDERS.best,
  SERVICE_PROVIDERS.aramex,
  SERVICE_PROVIDERS.kex
];

export const WEBHOOKLESS_SERVICE_PROVIDERS = [
  SERVICE_PROVIDERS.poslaju,
  SERVICE_PROVIDERS.citylink,
  SERVICE_PROVIDERS.lineclear,
  SERVICE_PROVIDERS.aramex,
];
